import "./App.scss";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login/Login";
import Simulator from "./pages/Simulator/Simulator";
import Dashboard from "./pages/Dashboard/Dashboard";
import Simulations from "./pages/Simulations/Simulations";
import Registration from "./pages/Registration/Registration";
import PrivateRouter from "./utils/private-router";
import Users from "./pages/Registration/Users/Users";
import PricesAndCosts from "./pages/Registration/PricesAndCosts/PricesAndCosts";
import Icms from "./pages/Registration/Icms/Icms";
import UploadExcel from "./pages/Registration/UploadExcel/UploadExcel";
import Competitors from "./pages/Registration/Competitors/Competitors";
import SellingZone from "./pages/Registration/SellingZone/SellingZone";
import PrivateRoles from "./utils/private-roles";
import Clients from "./pages/Clients/Clients";
import Cities from "./pages/Cities/Cities";
import Companies from "./pages/Companies/Companies";
import CompanyById from "./pages/Companies/CompanyById/CompanyById";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import UserById from "./pages/Registration/Users/UserById/UserById";
import SimulationById from "./pages/Simulations/SimulationById/SimulationById";
import CitiesById from "./pages/Cities/CitiesById/CitiesById";
import CsvPage from "./pages/Dashboard/CsvPage/CsvPage";
import VolumeZona from "./pages/Dashboard/VolumeZona/VolumeZona";
import VolumeCidade from "./pages/Dashboard/VolumeCidade/VolumeCidade";
import VolumeEmpresa from "./pages/Dashboard/VolumeEmpresa/VolumeEmpresa";
import VolumeProduto from "./pages/Dashboard/VolumeProduto/VolumeProduto";
import VolumeCovep from "./pages/Dashboard/VolumeCovep/VolumeCovep";
import VolumeConcorrente from "./pages/Dashboard/VolumeConcorrente/VolumeConcorrente";
import VolumeUsuario from "./pages/Dashboard/VolumeUsuario/VolumeUsuario";

function App() {
  return (
    <Routes>
      {/* { public routes } */}
      <Route path="/" element={<Login />} />
      <Route path="/resetar-senha" element={<ResetPassword />} />

      {/* { private routes } */}
      <Route element={<PrivateRouter />}>
        <Route element={<PrivateRoles permission={[1, 2, 3, 5, 6]} />}>
          <Route path="/simulador" element={<Simulator />} />
        </Route>
        <Route element={<PrivateRoles permission={[1, 2, 3, 5, 6]} />}>
          <Route exact path="/simulacoes">
            <Route index element={<Simulations />} />
            <Route exact path=":id" element={<SimulationById />} />
          </Route>
        </Route>
        <Route element={<PrivateRoles permission={[1, 2]} />}>
          <Route exact path="/dashboard">
            <Route index element={<Dashboard />} />
            <Route element={<PrivateRoles permission={[1, 2, 4]} />}>
              <Route path="csv" element={<CsvPage />} />
            </Route>
            <Route element={<PrivateRoles permission={[1, 4]} />}>
              <Route path="volume-zona" element={<VolumeZona />} />
            </Route>
            <Route element={<PrivateRoles permission={[1, 4]} />}>
              <Route path="volume-cidade" element={<VolumeCidade />} />
            </Route>
            <Route element={<PrivateRoles permission={[1, 4]} />}>
              <Route path="volume-empresa" element={<VolumeEmpresa />} />
            </Route>
            <Route element={<PrivateRoles permission={[1, 4]} />}>
              <Route path="volume-produto" element={<VolumeProduto />} />
            </Route>
            <Route element={<PrivateRoles permission={[1, 4]} />}>
              <Route path="volume-covep" element={<VolumeCovep />} />
            </Route>
            <Route element={<PrivateRoles permission={[1, 4]} />}>
              <Route path="volume-usuario" element={<VolumeUsuario />} />
            </Route>
            <Route element={<PrivateRoles permission={[1, 4]} />}>
              <Route
                path="volume-concorrente"
                element={<VolumeConcorrente />}
              />
            </Route>
          </Route>
        </Route>
        <Route element={<PrivateRoles permission={1} />}>
          <Route exact path="/cidades">
            <Route index element={<Cities />} />
            <Route path=":id" element={<CitiesById />} />
          </Route>
        </Route>
        <Route element={<PrivateRoles permission={[1]} />}>
          <Route path="/clientes" element={<Clients />} />
        </Route>
        <Route exact path="/cadastro">
          <Route index element={<Registration />} />
          <Route element={<PrivateRoles permission={[1, 4]} />}>
            <Route path="usuarios" element={<Users />} />
          </Route>
          <Route element={<PrivateRoles permission={[1]} />}>
            <Route exact path="usuarios/:id" element={<UserById />} />
          </Route>
          <Route element={<PrivateRoles permission={[1]} />}>
            <Route path="preco-custo" element={<PricesAndCosts />} />
          </Route>
          <Route element={<PrivateRoles permission={[1, 2]} />}>
            <Route path="icms" element={<Icms />} />
          </Route>
          <Route element={<PrivateRoles permission={[1]} />}>
            <Route path="excel" element={<UploadExcel />} />
          </Route>
          <Route element={<PrivateRoles permission={[1]} />}>
            <Route path="concorrentes" element={<Competitors />} />
          </Route>
          <Route element={<PrivateRoles permission={[1]} />}>
            <Route path="zonas-venda" element={<SellingZone />} />
          </Route>
        </Route>
        <Route element={<PrivateRoles permission={1} />}>
          <Route exact path="/empresas">
            <Route index element={<Companies />} />
            <Route path=":id" element={<CompanyById />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
